import { Check, LoaderCircle } from "lucide-react";
import { formatCurrency } from "@/lib/goals";

export const CofreSquaresGrid = ({ goal, updating, onSelect, locked = false }) => (
  <section data-testid="goal-squares-section" className="cofre-board">
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <p className="text-sm font-bold uppercase tracking-wide text-amber-800">Seu cofrinho</p>
        <h2 className="mt-1 font-heading text-2xl font-extrabold text-emerald-950">
          Marque cada valor que guardar
        </h2>
      </div>
      <p data-testid="squares-count" className="text-base font-bold text-slate-600">
        {goal.marked_count} de {goal.square_count} marcados
      </p>
    </div>
    <p className="mt-2 text-lg text-slate-600">
      {locked ? "Esta meta ainda não está disponível para receber depósitos." : "Toque em um valor para registrar como você guardou."}
    </p>
    <p
      data-testid="squares-total-explanation"
      className="mt-3 rounded-xl border border-amber-300 bg-white/70 px-4 py-3 text-base font-bold text-emerald-950"
    >
      Estes {goal.square_count} quadradinhos somam exatamente {formatCurrency(goal.amount_cents)}.
    </p>
    <div
      data-testid="squares-grid-container"
      className="mt-7 grid grid-cols-2 gap-2.5 sm:grid-cols-3 sm:gap-3.5 md:grid-cols-4 lg:grid-cols-6"
    >
      {goal.square_values.map((value, index) => {
        const marked = goal.marked_squares.includes(index);
        const loading = updating === index;
        return (
          <button
            key={index}
            type="button"
            onClick={() => onSelect(index)}
            disabled={marked || updating !== null || locked}
            aria-pressed={marked}
            aria-label={`Quadradinho ${index + 1}, ${formatCurrency(value)}, ${marked ? "marcado" : "não marcado"}`}
            data-testid={`square-toggle-button-${index}`}
            className={`cofre-value-square min-h-[72px] rounded-xl border-2 px-2 py-2 text-center transition-[transform,background-color,border-color,box-shadow] duration-150 active:scale-95 disabled:opacity-60 ${marked ? "cofre-value-square-marked" : "cofre-value-square-pending"}`}
          >
            {loading ? (
              <LoaderCircle className="mx-auto h-5 w-5 animate-spin" />
            ) : (
              <>
                <span
                  data-testid={`square-item-value-${index}`}
                  className="block whitespace-nowrap font-heading text-sm font-extrabold sm:text-base"
                >
                  {formatCurrency(value)}
                </span>
                <span className="mt-1 flex items-center justify-center gap-1 text-xs font-bold">
                  {marked ? <Check className="h-3.5 w-3.5" strokeWidth={3} /> : null}
                  {marked ? "Guardado" : "Guardar"}
                </span>
              </>
            )}
          </button>
        );
      })}
    </div>
  </section>
);